import { Flex, Menu, MenuContent, MenuTrigger } from '@optiaxiom/react';
import { IconAngleDown, IconFilter } from '@optimizely/axiom-icons';
import { useDecision } from '@optimizely/react-sdk';

import { AgentStatus, AgentType } from '../../../hooks/useAgentsUrlParams';

type AgentFiltersProps = {
  agentType?: AgentType;
  status?: AgentStatus;
  onAgentTypeChange: (type?: AgentType) => void;
  onStatusChange: (status?: AgentStatus) => void;
};

export function AgentFilters({
  agentType,
  status,
  onAgentTypeChange,
  onStatusChange,
}: AgentFiltersProps) {
  const [workflowAgentFeature] = useDecision('workflow-agent');

  const getTypeLabel = () => {
    switch (agentType) {
      case 'specialized':
        return 'Specialized';
      case 'workflow':
        return workflowAgentFeature.enabled ? 'Workflow' : 'All Types';
      default:
        return 'All Types';
    }
  };

  const getStatusLabel = () => {
    switch (status) {
      case 'active':
        return 'Active';
      case 'inactive':
        return 'Inactive';
      default:
        return 'All Status';
    }
  };

  const agentTypeOptions = [
    {
      label: 'All Types',
      execute: () => onAgentTypeChange(undefined),
    },
    {
      label: 'Specialized',
      execute: () => onAgentTypeChange('specialized'),
    },
  ];

  if (workflowAgentFeature.enabled) {
    agentTypeOptions.push({
      label: 'Workflow',
      execute: () => onAgentTypeChange('workflow'),
    });
  }

  const statusOptions = [
    {
      label: 'All Status',
      execute: () => onStatusChange('all'),
    },
    {
      label: 'Active',
      execute: () => onStatusChange('active'),
    },
    {
      label: 'Inactive',
      execute: () => onStatusChange('inactive'),
    },
  ];

  return (
    <Flex gap="12" flexDirection="row" alignItems="center">
      <Menu options={agentTypeOptions}>
        <MenuTrigger
          appearance="subtle"
          addonBefore={<IconFilter size="16" />}
          addonAfter={<IconAngleDown size="16" />}
          size="md"
        >
          {getTypeLabel()}
        </MenuTrigger>
        <MenuContent />
      </Menu>

      <Menu options={statusOptions}>
        <MenuTrigger
          appearance="subtle"
          addonBefore={<IconFilter size="16" />}
          addonAfter={<IconAngleDown size="16" />}
          size="md"
        >
          {getStatusLabel()}
        </MenuTrigger>
        <MenuContent />
      </Menu>
    </Flex>
  );
}
